
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.256 4.43l-.933-1.688a.325.325 0 01.001-.315l.929-1.669a.325.325 0 00-.284-.482h-8.453a.677.677 0 00-.677.677v6.669h1.94v-2.71h7.192a.325.325 0 00.285-.482zM21.808 19.506a1.098 1.098 0 100-2.196 1.098 1.098 0 000 2.196z"}}),_c('path',{attrs:{"d":"M28.734 25.984a.83.83 0 00.83-.83v-8.47c0-3.84-3.02-6.979-6.786-7.117v5.963a3.041 3.041 0 012.064 3.037 3.05 3.05 0 01-2.91 2.877 3.04 3.04 0 01-3.161-3.035c0-1.336.867-2.473 2.068-2.878V9.56h-8.813a8.325 8.325 0 013 6.4v10.023h13.708zM12.311 27.924v.91a2.665 2.665 0 005.33 0v-.91h-5.33zM4.586 19.864h4.2v2.05h-4.2v-2.05z"}}),_c('path',{attrs:{"d":"M6.648 9.562C3.117 9.582.286 12.5.286 16.032v9.122c0 .458.371.83.83.83h11.97V15.962a6.407 6.407 0 00-6.438-6.4zm3.895 13.23a.878.878 0 01-.879.879H3.708a.878.878 0 01-.879-.879v-3.807c0-.485.393-.878.879-.878h5.956c.485 0 .879.393.879.878v3.807z"}})])
          )
        }
      }
    